import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { injectIntl } from "react-intl";
import "./order-list-table.scss";
import Pagination from "../pagination/order-list-pagination";
import TableGroup from "./order-list-table-group";
import Empty from "../empty";

class OrderListTable extends Component {
    state = {};

    isEmpty = () => _.isEmpty(this.getList());

    getList = () => (this.props.orderList ? this.props.orderList : {});

    renderTable = () => {
        return (
            <div className="order-table-wrapper">
                {Object.keys(this.getList()).map((key) => {
                    const list = Array.isArray(_.get(this.getList(), `${key}.list`))
                        ? _.get(this.getList(), `${key}.list`)
                        : [];
                    const title = _.get(this.getList(), `${key}.title`) ? _.get(this.getList(), `${key}.title`) : {};
                    return <TableGroup key={key} title={title} list={list} />;
                })}
            </div>
        );
    };

    renderEmpty = () => {
        return <Empty {...this.props} />;
    };

    renderPagination = () => {
        return <Pagination />;
    };

    render() {
        return (
            <div>
                <div
                    className="order-list-wrapper"
                    style={{ height: isNaN(this.props.height) ? 0 : this.props.height }}
                >
                    {this.isEmpty() ? this.renderEmpty() : this.renderTable()}
                </div>
                {this.renderPagination()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lan: _.get(state, "settings.lan", "en"),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(OrderListTable));
